import { I18nInfo } from '@/user/models'

const i18n = new I18nInfo('common')

/**
 * @enum {string}
 */
export const APPLY_STATE = {
  DRAFT: i18n.translate('certification.applyState.DRAFT'),
  APPLIED: i18n.translate('certification.applyState.APPLIED'),
  SCHEDULED: i18n.translate('certification.applyState.SCHEDULED'),
  DROPPED: i18n.translate('certification.applyState.DROPPED'),
  CANCELED: i18n.translate('certification.applyState.CANCELED'),
  IN_PROGRESS: i18n.translate('certification.applyState.IN_PROGRESS'),
  COMPLETED: i18n.translate('certification.applyState.COMPLETED'),
}

export const APPLICANT_RESULT_STATE = {
  PASSED: i18n.translate('certification.applyResult.PASSED'),
  FAILED: i18n.translate('certification.applyResult.FAILED'),
  NOT_ATTENDED: i18n.translate('certification.applyResult.NOT_ATTEND'),
}
